import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdaSectionActsComponent } from './components/sections/pda-section-acts/pda-section-acts.component';
import { PdaSectionGeneralDataComponent } from './components/sections/pda-section-general-data/pda-section-general-data.component';
import { PdaSectionPartyComponent } from './components/sections/pda-section-party/pda-section-party.component';
import { PdaSectionSchedulesComponent } from './components/sections/pda-section-schedules/pda-section-schedules.component';
import { PdaLoginIconComponent } from './components/pda-login-icon/pda-login-icon.component';
import { CommonTLFModule } from 'src/app/common/common.module';
import { PdaSectionNodataComponent } from './components/sections/common/pda-section-no-data/pda-section-nodata/pda-section-nodata.component';
import { FilterPipe } from './utils/pipe/filter.pipe';
import { CancelleriaTelematicaComponent } from './pages/cancelleria-telematica/cancelleria-telematica.component';
import { PdaRoutingModule } from './pda-routing.module';
import { ConsultazioneAnonimaComponent } from './pages/consultazione-anonima/consultazione-anonima.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PctSidebarLinkComponent } from './components/pct-sidebar-link/pct-sidebar-link.component';
import { PctEventsSidebarLinkComponent } from './components/pct-events-sidebar-link/pct-events-sidebar-link.component';
import { ConsultazioneComponent } from './pages/consultazione/consultazione.component';
import { ConsultazioneListComponent } from './pages/consultazione/components/consultazione-list/consultazione-list.component';
import { PdaFascicolopctEditComponent } from './components/pda-fascicolopct-edit/pda-fascicolopct-edit.component';
import { AggiornamentoMassivoDisclaimerComponent } from './pages/cancelleria-telematica/components/aggiornamento-massivo-disclaimer/aggiornamento-massivo-disclaimer.component';
import { GestioneDelegheComponent } from './pages/gestione-deleghe/gestione-deleghe/gestione-deleghe.component';
import { GestionePagamentiComponent } from './pages/gestione-pagamenti/gestione-pagamenti.component';
import { GeneraAvvisoModalComponent } from './pages/gestione-pagamenti/components/genera-avviso-modal/genera-avviso-modal/genera-avviso-modal.component';
import { PagamentiListComponent } from './pages/gestione-pagamenti/components/pagamenti-list/pagamenti-list/pagamenti-list.component';
import { PagamentiDetailComponent } from './pages/gestione-pagamenti/components/pagamenti-detail/pagamenti-detail/pagamenti-detail.component';
import { PagamentiSearchComponent } from './pages/gestione-pagamenti/components/pagamenti-search/pagamenti-search/pagamenti-search.component';
import { DownloadAvvisoDisclaimerComponent } from './pages/gestione-pagamenti/components/download-avviso-disclaimer/download-avviso-disclaimer.component';
import { ConsultazioneAnonimaListFascicoliComponent } from './pages/consultazione-anonima/components/consultazione-anonima-list-fascicoli/consultazione-anonima-list-fascicoli.component';
import { ConsultazioneAnonimaListRicorsiComponent } from './pages/consultazione-anonima/components/consultazione-anonima-list-ricorsi/consultazione-anonima-list-ricorsi.component';
import { ConsultazioneAnonimaFascicoloModalComponent } from './pages/consultazione-anonima/components/consultazione-anonima-fascicolo-modal/consultazione-anonima-fascicolo-modal.component';



@NgModule({
  declarations: [
    PdaSectionActsComponent,
    PdaSectionGeneralDataComponent,
    PdaSectionPartyComponent,
    PdaSectionSchedulesComponent,
    PdaLoginIconComponent,
    PdaSectionNodataComponent,
    FilterPipe,
    CancelleriaTelematicaComponent,
    ConsultazioneAnonimaComponent,
    PctSidebarLinkComponent,
    PctEventsSidebarLinkComponent,
    ConsultazioneComponent,
    ConsultazioneListComponent,
    PdaFascicolopctEditComponent,
    AggiornamentoMassivoDisclaimerComponent,
    GestioneDelegheComponent,
    GestionePagamentiComponent,
    GeneraAvvisoModalComponent,
    PagamentiListComponent,
    PagamentiDetailComponent,
    PagamentiSearchComponent,
    DownloadAvvisoDisclaimerComponent,
    ConsultazioneAnonimaListFascicoliComponent,
    ConsultazioneAnonimaListRicorsiComponent,
    ConsultazioneAnonimaFascicoloModalComponent
  ],
  imports: [
    CommonModule,
    CommonTLFModule,
    PdaRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    PdaSectionActsComponent,
    PdaSectionGeneralDataComponent,
    PdaSectionPartyComponent,
    PdaSectionSchedulesComponent,
    PdaLoginIconComponent,
    PdaSectionNodataComponent,
    FilterPipe,
    CancelleriaTelematicaComponent,
    ConsultazioneAnonimaComponent,
    PctSidebarLinkComponent,
    PctEventsSidebarLinkComponent,
    ConsultazioneComponent,
    ConsultazioneListComponent,
    PdaFascicolopctEditComponent,
    AggiornamentoMassivoDisclaimerComponent,
    GestioneDelegheComponent,
    GestionePagamentiComponent,
    GeneraAvvisoModalComponent,
    PagamentiListComponent,
    PagamentiDetailComponent,
    PagamentiSearchComponent,
    DownloadAvvisoDisclaimerComponent
  ]
})
export class PdaModule { }
